import React from "react";

const FooterBottom = () => {
  return (
    <div className="w-full py-10">
      <p className="text-base text-center text-gray-500">
        © All rights reserved by Mujahidul Islam
      </p>
    </div>
  );
};

export default FooterBottom;
